import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {
    ApiCallOptions,
    PaginatedResponse,
    Delegation,
    CreateDelegationRequest,
    DelegationsListParams,
    RevokeDelegationParams
} from './api.d';

export const getDelegations = (accountUserId: string, params?: DelegationsListParams, options: ApiCallOptions = {}) => createApiCall<PaginatedResponse<Delegation>>(SERVICE_NAMES.DELEGATION, 'GET', `account-users/${accountUserId}/delegations`)({...options, params});

export const getDelegation = (accountUserId: string, delegatedAccountUserId: string, options: ApiCallOptions = {}) => createApiCall<Delegation>(SERVICE_NAMES.DELEGATION, 'GET', `account-users/${accountUserId}/delegations/${delegatedAccountUserId}`)({...options});

export const createDelegation = (accountUserId: string, data: CreateDelegationRequest, options: ApiCallOptions = {}) => createApiCall<Delegation>(SERVICE_NAMES.DELEGATION, 'POST', `account-users/${accountUserId}/delegations`)({...options, data});

export const revokeDelegation = (accountUserId: string, params: RevokeDelegationParams, options: ApiCallOptions = {}) => createApiCall<void>(SERVICE_NAMES.DELEGATION, 'DELETE', `account-users/${accountUserId}/delegations/revoke`)({...options, params});

export const getDelegators = (accountUserId: string, params?: DelegationsListParams, options: ApiCallOptions = {}) => createApiCall<PaginatedResponse<Delegation>>(SERVICE_NAMES.DELEGATION, 'GET', `account-users/${accountUserId}/delegators`)({...options, params});

export const delegationApi = {
    getDelegations,
    getDelegation,
    createDelegation,
    revokeDelegation,
    getDelegators
};
